"use client";

import { useState, useEffect } from "react";
import { debounce, isWindowDefined } from "@huub-web/utils";

export const useWindowSize = () => {
  if (!isWindowDefined()) {
    return null;
  }

  // biome-ignore lint/correctness/useHookAtTopLevel: intentional early return for SSR — hooks only run in browser environment
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  // biome-ignore lint/correctness/useHookAtTopLevel: intentional early return for SSR — hooks only run in browser environment
  useEffect(() => {
    if (!isWindowDefined()) {
      return;
    }

    const handleResize = debounce(() => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }, 100);

    window.addEventListener("resize", handleResize);

    setWindowSize({
      width: window.innerWidth,
      height: window.innerHeight,
    });

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return windowSize;
};
